import React from "react";
import {Breadcrumb, Layout, Menu} from "antd";
import {ExperimentIMG} from "./ExperimentIMG";
import {ExperimentContent} from "./ExperimentContent";
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"
import robotLogo from "../IMG/robotLogo.png";

export function ExperimentDetailsLayout(){

    const experimentPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/class"
    }
    const { SubMenu } = Menu;
    const { Header, Content, Sider } = Layout;
    const layout = (
        <Layout>
            <Header className="header">
                <div className="logo" />
                {/*<Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>*/}
                {/*    <Menu.Item key="1">RPA审计机器人课程平台</Menu.Item>*/}
                {/*    /!*<Menu.Item key="2">nav 2</Menu.Item>*/}
                {/*    <Menu.Item key="3">nav 3</Menu.Item>*!/*/}
                {/*</Menu>*/}
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    backgroundImage: `url(${robotLogo})`,
                    backgroundSize:"100% 100%",
                    color:"white"
                }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                </div>
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    color:"white",
                    fontSize:"30px",
                    margin:"0 0 0 530px",
                    fontFamily: "STKaiti"
                }}>RPA审计机器人课程平台</div>
            </Header>
            <Layout>

                <Layout style={{ padding: '0 24px 24px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        {/*<Breadcrumb.Item>Home</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>List</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>App</Breadcrumb.Item>*/}
                    </Breadcrumb>
                    <Content
                        className="site-layout-background"
                        style={{
                            //overflow: 'initial',
                            minHeight: document.body.clientHeight
                        }}
                        // style={{
                        //     // padding: 24,
                        //     // margin: 0,
                        //     // minHeight: 280,
                        //     // height: 615,
                        //     marginTop: 17,
                        //     padding: 24,
                        //     //minHeight: "100%",
                        //     height: 615,
                        // }}
                    >
                        <ExperimentContent></ExperimentContent>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )

    return(
        layout
    )
}
